import { Search } from "lucide-react"
import type { LoadBalancerFilters as LoadBalancerFiltersType, PaginationState } from '@/features/fmo'

interface LoadBalancerFiltersProps {
  filters: LoadBalancerFiltersType
  pagination: PaginationState
  onFiltersChange: (filters: Partial<LoadBalancerFiltersType>) => void
  onPaginationChange: (pagination: Partial<PaginationState>) => void
}

export default function LoadBalancerFilters({
  filters,
  pagination,
  onFiltersChange,
  onPaginationChange
}: LoadBalancerFiltersProps) {
  return (
    <div className="bg-white rounded-3xl shadow-xl border border-gray-200 p-6 mb-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="text"
            placeholder="Search organizations..."
            value={filters.searchTerm}
            onChange={(e) => onFiltersChange({ searchTerm: e.target.value })}
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <select
          value={filters.statusFilter}
          onChange={(e) => onFiltersChange({ statusFilter: e.target.value as any })}
          className="px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
        <select
          value={filters.typeFilter}
          onChange={(e) => onFiltersChange({ typeFilter: e.target.value as any })}
          className="px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="all">All Types</option>
          <option value="EM">EM</option>
          <option value="DM">DM</option>
          <option value="CM">CM</option>
        </select>
        <select
          value={pagination.itemsPerPage}
          onChange={(e) => onPaginationChange({ itemsPerPage: Number(e.target.value) })}
          className="px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value={5}>5 per page</option>
          <option value={10}>10 per page</option>
          <option value={20}>20 per page</option>
        </select>
      </div>
    </div>
  )
}
